import React from "react";
import { Gender } from '../../utils/Constants';
import {useTranslation} from "react-i18next"; // Adjust the import path as necessary

interface GenderPickerProps {
  gender: Gender | undefined;
  setGender: (value: Gender) => void;
  isValid: boolean;
  errorMessage: string;
}

export const GenderPicker: React.FC<GenderPickerProps> = ({
                                                            gender,
                                                            setGender,
                                                            isValid,
                                                            errorMessage,
                                                          }) => {
  const { t } = useTranslation();
  return (
    <div className="my-4">
      <label className="block text-sm font-medium mb-2 text-left">{t('Gender')}</label>
      <div
        className={`border-2 ${
          isValid ? "border-white" : "border-red-500"
        } rounded-md p-2`}
      >
        <div className="flex justify-between">
          <div className="flex items-center">
            <input
              type="radio"
              id="male"
              name="gender"
              value={Gender.MALE}
              checked={gender === Gender.MALE}
              onChange={() => setGender(Gender.MALE)}
              className="mr-2"
            />
            <label htmlFor="male" className="text-white">
              {t('Male')}
            </label>
          </div>
          <div className="flex items-center">
            <input
              type="radio"
              id="female"
              name="gender"
              value={Gender.FEMALE}
              checked={gender === Gender.FEMALE}
              onChange={() => setGender(Gender.FEMALE)}
              className="mr-2"
            />
            <label htmlFor="female" className="text-white">
              {t('Female')}
            </label>
          </div>
        </div>
      </div>
      {!isValid && <p className="text-red-500 text-sm mt-2">{errorMessage}</p>}
    </div>
  )
};